module.exports = __webpack_public_path__ + "static/media/sct.ec1df600.png";